import { ReactNode } from 'react';

import { createDependenciesContext } from '@dreryk/react-common';

type AccountConfigurationVerificationEventInterceptorConstructor = (props: { children: ReactNode }) => JSX.Element;

export type VisitDependencies = {
   accountConfigurationVerificationEventInterceptor: AccountConfigurationVerificationEventInterceptorConstructor;
};

const [useVisitDependenciesContext, VisitDependenciesContextProvider] = createDependenciesContext<
   VisitDependencies & { contextName: 'Visit' }
>('Visit');

export { useVisitDependenciesContext, VisitDependenciesContextProvider };
